import { useCMSQuery } from '@develop/ia-api-library'
import { GetSettingsShowLogs } from '~/models/generated/cms'
import type { GetSettingsShowLogsQuery } from '~/models/generated/cms'

export const onShowLogs = async (cb: () => void) => {
  const config = useRuntimeConfig()

  // Store the fetched value in a global state using `useState` to avoid multiple calls
  const showLogs = useState<boolean | null>('showLogs', () => null)

  // Fetch data only if it hasn't been fetched yet
  if (showLogs.value === null) {
    try {
      const { data } = await useCMSQuery<GetSettingsShowLogsQuery>({
        query: GetSettingsShowLogs,
        cachePolicy: 'network-only',
      })
      showLogs.value = data?.value?.setting?.data?.attributes?.showLogs ?? true
    } catch (error) {
      showLogs.value = true // Default value in case of error
    }
  }

  // Execute the callback if conditions are met
  if (config.public.appEnv === 'dev' || showLogs.value) {
    cb()
  }
}
